module.exports = __webpack_public_path__ + "ec515d10c2bc4074bbb62101c684eb3d.jpg";